import { render, staticRenderFns } from "./OleMissExperiment9PrelabQuestion2.vue?vue&type=template&id=0906fed6&"
import script from "./OleMissExperiment9PrelabQuestion2.vue?vue&type=script&lang=js&"
export * from "./OleMissExperiment9PrelabQuestion2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VForm,VRow,VSimpleTable,VTextField})
